import Http from "../Http";
import { INSPECTION_URL } from "../Helper";

/**
 * Save or update an inspection report
 * @param {Object} reportData - The inspection report data to save
 * @returns {Promise}
 */

export function saveAnalystFsInspectionReport(reportData) {
    return (dispatch) =>
        new Promise((resolve, reject) => {
            Http.post(INSPECTION_URL + "save_analyst_fsinspection_report", reportData)
                .then((res) => {
                    return resolve(res.data);
                })
                .catch((err) => {
                    return reject(err);
                });
        });
}

export function getAnalystFsInspectionReport(reportId) {
    return (dispatch) =>
        new Promise((resolve, reject) => {
            Http.get(INSPECTION_URL + "get_analyst_fsinspection_report/" + reportId)
                .then((res) => resolve(res.data))
                .catch((err) => reject(err));
        });
}

export function getAnalystFsInspectionRequest(requestId) {
    return (dispatch) =>
        new Promise((resolve, reject) => {
            Http.get(INSPECTION_URL + "get_analyst_fsinspection_request/" + requestId)
                .then((res) => resolve(res.data))
                .catch((err) => reject(err));
        });
}

export function generateAnalystPdfInspectionReport(reportId) {
    return (dispatch) =>
        new Promise((resolve, reject) => {
            Http.get(INSPECTION_URL + "generate-analyst-pdf/" + reportId)
                .then((res) => resolve(res.data))
                .catch((err) => reject(err));
        });
}